import React from 'react'
import ProductCard from '../ProductCard'
import latext from '../../assets/latext.webp'
import gnae from '../../assets/gynae.jpeg'
import surgical from '../../assets/surg.jpeg'
import syringes from '../../assets/syringes.webp'
import cat from '../../assets/cat.webp'
import pack from '../../assets/pack.jpeg'

    const data = [
        {
            id: 1,
            name: 'Latex Examination Gloves',
            imgSrc: latext,
        },
        {
            id: 2,
            name: 'Gynaecological Gloves',
            imgSrc: gnae,
        },
        {
            id: 3,
            name: 'Surgical Gloves',
            imgSrc: surgical,
        },
        {
            id: 4,
            name: 'Syringes',
            imgSrc: syringes,
        },
        {
            id: 5,
            name: 'Urinary Catheter & NG tubes',
            imgSrc: cat,
        },
        {
            id: 6,
        name: 'Laparotomy & Caesarean Pack',
            imgSrc: pack,
        },
    ]

export default function Card4() {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {data.map((item, index) => (
                <ProductCard key={item.id} product={item} index={index} />
            ))}
        </div>
    )
}
